module.exports = __webpack_public_path__ + "static/media/fire-svgrepo-com.a8f5f01f.svg";